export const notificationCategories = Object.freeze({ message: 2, reminder: 1, notification: 0 })
export const reminderTypes = Object.freeze({ lastmessage: 0, birthday: 1 })